import { ICat, ICatBimestre, ICatEdad, ICatEstado, ICatMes, ICatMetricaEcuve, ICatMetricaIfrf, ICatMetricaSisevive, ICatNivelIngreso, ICatPeriodo, ICatRama, ICatTamanyoEmpresa, ICatTipoCredito, ICatTipoLinea, ICatTipoProducto, ICatVarEcuve, ICatVarEcuveSisevive, ICatVarIfrf, ICatVarSisevive, ICatVariable, ICatVivienda, IGetDimNvelMvldAdca, IGetDimZonaCnsnUrba, IMes } from "./Interfaces";

export interface Catalogo<I extends ICat> {
    nombre:CatalogoEnum,
    json:I[],
}

enum CatalogoEnum {
    CAT_CUBO_RAMAS		= "cat_cubo_ramas",			//Métricas cubo de Indicadores de Otorgamiento de Crédito
    CAT_VARIABLES		= "cat_variables",			//iables / Dimensiones   Indicadores de Otorgamiento de Crédito
    CAT_TIPO_PRODUCTO	= "cat_tipo_producto",
    CAT_VIVIENDA		= "cat_vivienda",
    CAT_ESTADOS			= "cat_estados",
    CAT_EDAD			= "cat_edad",
    CAT_NIVEL_INGRESO   = "cat_nivel_ingreso",
    CAT_TIPO_CREDITO	= "cat_tipo_credito",
    CAT_TIPO_LINEA		= "cat_tipo_linea",
    CAT_MESES			= "cat_meses",
    CAT_BIMESTRES		= "cat_bimestres",
    CAT_PERIODOS	 	= "cat_periodos",			// Años del combo en el cubo de Indicadores de Otorgamiento de Crédito
    CAT_TAM_EMPRESA    = "cat_tamanyo_empresa",
    SERV_PDF_AYUDA		= "servpdfayuda", // e++ ?

    CAT_VARIABLES_IFRF 		 	= "cat_variables_ifrf",
    CAT_METRICAS_IFRF 		 	= "cat_metricas_ifrf",
    CAT_VARIABLES_ECUVE_SISEVIVE= "cat_variables_ecuvesisevive",
    CAT_VARIABLES_ECUVE 		= "cat_variables_ecuve",
    CAT_VARIABLES_SISEVIVE 		= "cat_variables_sisevive",
    CAT_METRICAS_ECUVE 		 	= "cat_metricas_ecuve",
    CAT_METRICAS_SISEVIVE 		= "cat_metricas_sisevive",

    CAT_GET_DIM_ZCU 		= "cat_get_dim_zcu",
    CAT_GET_DIM_NMA 		= "cat_get_dim_nma",
}

const myFetch = async (catalogo:string) => {
    /*
    const respEnc = await get(  '/catalogosRest/getCatalogo?catalogo='+catalogo )
    .then( ( response ) => {
        console.log( response.statusText)
        return response.data ;
    });*/

    const response = await fetch( process.env.REACT_APP_CONTEXT_PATH_REST + '/catalogosRest/getCatalogo?catalogo='+catalogo )
        .then( resp => {
            return resp.json()
        })
        .then( data => {
            return data;
        })
        .catch(e=> {
            //console.error(catalogo, e)
        })
    return response;
        
}

const consultaCatalogo= async( catalogo:string ) => {
    const data = await myFetch( catalogo ).then( data =>{
        return data;
    })
    return JSON.parse( JSON.stringify( data ) );
}

export class Catalogos {

    static CAT_CUBO_RAMAS:Catalogo<ICatRama> ;
    static CAT_VARIABLES:Catalogo<ICatVariable> ;
	static CAT_TIPO_PRODUCTO:Catalogo<ICatTipoProducto> ;
	static CAT_VIVIENDA:Catalogo<ICatVivienda> ;
	static CAT_ESTADOS:Catalogo<ICatEstado> ;
	static CAT_EDAD:Catalogo<ICatEdad> ;
	static CAT_NIVEL_INGRESO:Catalogo<ICatNivelIngreso> ;
	static CAT_TIPO_CREDITO:Catalogo<ICatTipoCredito> ;
	static CAT_TIPO_LINEA:Catalogo<ICatTipoLinea> ;
	static CAT_MESES:Catalogo<ICatMes> ;
	static CAT_BIMESTRES:Catalogo<ICatBimestre> ;
	static CAT_PERIODOS:Catalogo<ICatPeriodo> ;
	static CAT_TAM_EMPRESA:Catalogo<ICatTamanyoEmpresa> ;
	static CAT_VARIABLES_IFRF:Catalogo<ICatVarIfrf> ;
	static CAT_METRICAS_IFRF:Catalogo<ICatMetricaIfrf> ;
	static CAT_VARIABLES_ECUVE_SISEVIVE:Catalogo<ICatVarEcuveSisevive> ;
	static CAT_VARIABLES_ECUVE:Catalogo<ICatVarEcuve> ;
	static CAT_VARIABLES_SISEVIVE:Catalogo<ICatVarSisevive>;
	static CAT_METRICAS_ECUVE:Catalogo<ICatMetricaEcuve> ;
	static CAT_METRICAS_SISEVIVE:Catalogo<ICatMetricaSisevive> ;

	static CAT_GET_DIM_ZCU:Catalogo<IGetDimZonaCnsnUrba> ;
	static CAT_GET_DIM_NMA:Catalogo<IGetDimNvelMvldAdca> ;

    static YEARS:string[]=[];
    static YEARSBIM:string[]=[];

    static MESES:IMes[]=[];

    static FIRST_DATE:Date=new Date( 1970 , 0 ,1 )
    static MIN_DATE:Date=new Date( 2012 , 0 ,1 )
    static MIN_ZCU_DATE:Date=new Date( 2022 , 0 ,1 )

    static init = async () => {
        Catalogos.CAT_CUBO_RAMAS = {nombre:CatalogoEnum.CAT_CUBO_RAMAS, json: await consultaCatalogo(CatalogoEnum.CAT_CUBO_RAMAS).then( value => value ) }
        Catalogos.CAT_VARIABLES = {nombre:CatalogoEnum.CAT_VARIABLES, json: await consultaCatalogo(CatalogoEnum.CAT_VARIABLES).then( value => value ) } // Ver Catalogos.java
        Catalogos.CAT_TIPO_PRODUCTO = {nombre:CatalogoEnum.CAT_TIPO_PRODUCTO, json: await consultaCatalogo(CatalogoEnum.CAT_TIPO_PRODUCTO).then( value => value ) }
        Catalogos.CAT_VIVIENDA = {nombre:CatalogoEnum.CAT_VIVIENDA, json: await consultaCatalogo(CatalogoEnum.CAT_VIVIENDA).then( value => value ) }
        Catalogos.CAT_ESTADOS = {nombre:CatalogoEnum.CAT_ESTADOS, json: await consultaCatalogo(CatalogoEnum.CAT_ESTADOS).then( value => value ) }
        Catalogos.CAT_EDAD = {nombre:CatalogoEnum.CAT_EDAD, json: await consultaCatalogo(CatalogoEnum.CAT_EDAD).then( value => value ) }
        Catalogos.CAT_NIVEL_INGRESO = {nombre:CatalogoEnum.CAT_NIVEL_INGRESO, json: await consultaCatalogo(CatalogoEnum.CAT_NIVEL_INGRESO).then( value => value ) }
        Catalogos.CAT_TIPO_CREDITO = {nombre:CatalogoEnum.CAT_TIPO_CREDITO, json: await consultaCatalogo(CatalogoEnum.CAT_TIPO_CREDITO).then( value => value ) }
        Catalogos.CAT_TIPO_LINEA = {nombre:CatalogoEnum.CAT_TIPO_LINEA, json: await consultaCatalogo(CatalogoEnum.CAT_TIPO_LINEA).then( value => value ) }
        Catalogos.CAT_MESES = {nombre:CatalogoEnum.CAT_MESES, json: await consultaCatalogo(CatalogoEnum.CAT_MESES).then( value => value ) }
        Catalogos.CAT_BIMESTRES = {nombre:CatalogoEnum.CAT_BIMESTRES, json:await  consultaCatalogo(CatalogoEnum.CAT_BIMESTRES).then( value => value ) }
        Catalogos.CAT_PERIODOS = {nombre:CatalogoEnum.CAT_PERIODOS, json: await consultaCatalogo(CatalogoEnum.CAT_PERIODOS).then( value => value ) }
        Catalogos.CAT_TAM_EMPRESA = {nombre:CatalogoEnum.CAT_TAM_EMPRESA, json: await consultaCatalogo(CatalogoEnum.CAT_TAM_EMPRESA).then( value => value ) }
        Catalogos.CAT_VARIABLES_IFRF = {nombre:CatalogoEnum.CAT_VARIABLES_IFRF, json: await consultaCatalogo(CatalogoEnum.CAT_VARIABLES_IFRF).then( value => value ) }
        Catalogos.CAT_METRICAS_IFRF = {nombre:CatalogoEnum.CAT_METRICAS_IFRF, json: await consultaCatalogo(CatalogoEnum.CAT_METRICAS_IFRF).then( value => value ) }
        Catalogos.CAT_VARIABLES_ECUVE_SISEVIVE = {nombre:CatalogoEnum.CAT_VARIABLES_ECUVE_SISEVIVE, json: await consultaCatalogo(CatalogoEnum.CAT_VARIABLES_ECUVE_SISEVIVE).then( value => value ) }
        Catalogos.CAT_VARIABLES_ECUVE = {nombre:CatalogoEnum.CAT_VARIABLES_ECUVE, json: await consultaCatalogo(CatalogoEnum.CAT_VARIABLES_ECUVE).then( value => value ) }
        Catalogos.CAT_VARIABLES_SISEVIVE = {nombre:CatalogoEnum.CAT_VARIABLES_SISEVIVE, json: await consultaCatalogo(CatalogoEnum.CAT_VARIABLES_SISEVIVE).then( value => value ) }
        Catalogos.CAT_METRICAS_ECUVE = {nombre:CatalogoEnum.CAT_METRICAS_ECUVE, json: await consultaCatalogo(CatalogoEnum.CAT_METRICAS_ECUVE).then( value => value ) }
        Catalogos.CAT_METRICAS_SISEVIVE = {nombre:CatalogoEnum.CAT_METRICAS_SISEVIVE, json: await consultaCatalogo(CatalogoEnum.CAT_METRICAS_SISEVIVE).then( value => value ) }

        Catalogos.CAT_GET_DIM_ZCU = {nombre:CatalogoEnum.CAT_GET_DIM_ZCU, json: await consultaCatalogo(CatalogoEnum.CAT_GET_DIM_ZCU).then( value => value ) }
        Catalogos.CAT_GET_DIM_NMA = {nombre:CatalogoEnum.CAT_GET_DIM_NMA, json: await consultaCatalogo(CatalogoEnum.CAT_GET_DIM_NMA).then( value => value ) }

        for (let i=0; i<Catalogos.CAT_PERIODOS.json.length;i++) {
            if ( !this.YEARS.includes( Catalogos.CAT_PERIODOS.json[i].IdAnio ) ) {
                this.YEARS.push( Catalogos.CAT_PERIODOS.json[i].IdAnio );
            }
        }

        for (let i=0; i<Catalogos.CAT_BIMESTRES.json.length;i++) {
            if ( !this.YEARSBIM.includes( Catalogos.CAT_BIMESTRES.json[i].Anio + '' ) ) {
                this.YEARSBIM.push( Catalogos.CAT_BIMESTRES.json[i].Anio + '' );
            }
        }

        this.MESES = [ 
            { label: 'Enero', numMes: 0, lastDay: 31 },
            { label: 'Febrero', numMes: 1, lastDay: 29 },
            { label: 'Marzo', numMes: 2, lastDay: 31 },
            { label: 'Abril', numMes: 3, lastDay: 30 },
            { label: 'Mayo', numMes: 4, lastDay: 31 },
            { label: 'Junio', numMes: 5, lastDay: 30 },
            { label: 'Julio', numMes: 6, lastDay: 31 },
            { label: 'Agosto', numMes: 7, lastDay: 31 },
            { label: 'Septiembre', numMes: 8, lastDay: 30 },
            { label: 'Octubre', numMes: 9, lastDay: 31 },
            { label: 'Noviembre', numMes: 10, lastDay: 30 },
            { label: 'Diciembre', numMes: 11, lastDay: 31 }
            ];
        console.log("Catalogos iniciados.")
        return "Catalogos iniciados."
    }
}